export default __webpack_public_path__ + "static/media/boxvideo-compressed.1bc64165.mp4";